"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FeatureFlagProvider;
var _ffReactClientSdk = require("@harnessio/ff-react-client-sdk");
var _jsxRuntime = require("react/jsx-runtime");
function FeatureFlagProvider(_ref) {
  var apiKey = _ref.apiKey,
    children = _ref.children;
  var targetProperties = {
    identifier: 'DTC-WebUser',
    name: 'DTC-WebUser'
  };
  if (!apiKey) {
    return children;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ffReactClientSdk.FFContextProvider, {
    apiKey: apiKey,
    target: targetProperties,
    async: true,
    options: {
      streamEnabled: false,
      debug: false
    },
    children: children
  });
}